export function isRouteActive(pathname: string, target: string, exact = false) {
  const clean = pathname.split("?")[0];
  if (exact) return clean === target;
  return clean === target || clean.startsWith(target + "/");
}
